import { render, staticRenderFns } from "./ChartPrpPorCanal.vue?vue&type=template&id=635592d8&"
import script from "./ChartPrpPorCanal.vue?vue&type=script&lang=js&"
export * from "./ChartPrpPorCanal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports